<template>
  <span>
    404 - Not Found
  </span>
</template>

<script lang="ts" setup>

</script>
